(() => {
  'use strict';
  function initialise(section) {
    if (section.dataset.pfpReady === 'true') return;
    const variantsNode = section.querySelector('[data-pfp-variants]');
    const control = section.querySelector('[data-pfp-variant]');
    if (!variantsNode || !control) return;
    let variants;
    try { variants = JSON.parse(variantsNode.textContent); } catch (_) { return; }
    section.dataset.pfpReady = 'true';
    const image = section.querySelector('[data-pfp-main-image]');
    const thumbnails = [...section.querySelectorAll('[data-pfp-image-url]')];
    const mobile = section.querySelector('[data-pfp-mobile-buy]');
    function showImage(button) {
      if (!button || !image || button.classList.contains('is-active')) return;
      image.src = button.dataset.pfpImageUrl;
      image.removeAttribute('srcset');
      image.alt = button.dataset.pfpImageAlt || '';
      if (button.dataset.pfpImageWidth) image.width = Number(button.dataset.pfpImageWidth);
      if (button.dataset.pfpImageHeight) image.height = Number(button.dataset.pfpImageHeight);
      thumbnails.forEach(item => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
    }
    thumbnails.forEach((button, index) => {
      button.addEventListener('click', () => showImage(button));
      button.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowLeft') next = (index + thumbnails.length - 1) % thumbnails.length;
        if (event.key === 'ArrowRight') next = (index + 1) % thumbnails.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = thumbnails.length - 1;
        thumbnails[next].focus();
        showImage(thumbnails[next]);
      });
    });
    function updateVariant(updateUrl = false) {
      const variant = variants.find(item => String(item.id) === control.value);
      if (!variant) return;
      const price = section.querySelector('[data-pfp-price]');
      if (price) price.textContent = variant.priceText;
      const compare = section.querySelector('[data-pfp-compare]');
      if (compare) { compare.hidden = !variant.compareText; compare.textContent = variant.compareText || ''; }
      const save = section.querySelector('[data-pfp-save]');
      if (save) { save.hidden = !variant.saveText; save.textContent = variant.saveText || ''; }
      const add = section.querySelector('[data-pfp-add]');
      if (add) { add.disabled = !variant.available; add.textContent = variant.buttonText || (variant.available ? `Add to cart — ${variant.priceText}` : section.dataset.pfpUnavailableLabel || 'Currently unavailable'); }
      const qty = section.querySelector('[data-pfp-quantity]');
      if (qty) {
        qty.min = String(variant.min || 1);
        qty.step = String(variant.step || 1);
        if (variant.max !== null && variant.max !== undefined) qty.max = String(variant.max);
        else qty.removeAttribute('max');
        if (!qty.checkValidity()) qty.value = String(variant.min || 1);
      }
      if (mobile) {
        mobile.querySelector('[data-pfp-mobile-price]').textContent = variant.priceText;
        mobile.querySelector('[data-pfp-mobile-choice]').textContent = variant.title && variant.title !== 'Default Title'
          ? variant.title : section.dataset.pfpProductTitle || 'PawFed';
        const availability = mobile.querySelector('[data-pfp-mobile-availability]');
        if (availability) {
          availability.hidden = variant.available;
          availability.textContent = variant.available ? '' : section.dataset.pfpUnavailableLabel || 'Currently unavailable';
        }
      }
      showImage(thumbnails.find(button => button.dataset.pfpImageId === String(variant.imageId)));
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url);
      }
    }
    control.addEventListener('change', () => updateVariant(true));
    updateVariant();
    if (mobile) {
      const form = section.querySelector('#PawFedProductForm');
      if (!form) return;
      const media = window.matchMedia('(max-width: 749px)');
      let frame = 0;
      function updateMobile() {
        const visible = section.isConnected && media.matches && form.getBoundingClientRect().bottom <= 0;
        mobile.hidden = !visible;
        document.body.classList.toggle('pfp-mobile-buy-visible', visible);
      }
      function scheduleMobile() {
        if (!frame) frame = window.requestAnimationFrame(() => { frame = 0; updateMobile(); });
      }
      window.addEventListener('scroll', scheduleMobile, { passive: true });
      window.addEventListener('resize', scheduleMobile, { passive: true });
      mobile.querySelector('[data-pfp-buy-return]').addEventListener('click', event => {
        event.preventDefault();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        form.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
        const target = control.type === 'hidden' ? section.querySelector('[data-pfp-quantity]') : control;
        target?.focus({ preventScroll: true });
      });
      function unload(event) {
        if (!event.target.contains(section)) return;
        window.removeEventListener('scroll', scheduleMobile);
        window.removeEventListener('resize', scheduleMobile);
        if (frame) window.cancelAnimationFrame(frame);
        document.body.classList.remove('pfp-mobile-buy-visible');
        document.removeEventListener('shopify:section:unload', unload);
      }
      document.addEventListener('shopify:section:unload', unload);
      updateMobile();
    }
    // Deliberately no submit listener: Shopify's existing native product form remains unchanged.
  }
  function initialiseDetails(section) {
    if (section.dataset.pfpDetailsReady === 'true') return;
    const nav = section.querySelector('[data-pfp-details-nav]');
    const copy = section.querySelector('.pfp-product-description');
    if (!nav || !copy) return;
    section.dataset.pfpDetailsReady = 'true';
    const headings = [...copy.querySelectorAll('h2,h3')];
    const matches = {
      features: /^(features|feeding that fits your routine)$/i,
      compatibility: /^before you buy$/i,
      setup: /^(setup|getting started|get your routine started)$/i,
      faq: /^(frequently asked questions|faqs?)$/i,
    };
    let count = 0;
    nav.querySelectorAll('[data-pfp-jump]').forEach(link => {
      const key = link.dataset.pfpJump;
      const heading = headings.find(item => matches[key]?.test(item.textContent.trim().replace(/\s+/g, ' ')));
      if (!heading) return;
      if (!heading.id) heading.id = `PawFedInfo-${section.dataset.pfpDetails.replace(/[^a-zA-Z0-9_-]/g, '')}-${key}`;
      heading.setAttribute('tabindex', '-1');
      link.href = `#${heading.id}`;
      link.hidden = false;
      link.addEventListener('click', () => window.requestAnimationFrame(() => heading.focus({ preventScroll: true })));
      count += 1;
    });
    nav.hidden = count === 0;
  }
  function initialiseAll(root = document) {
    if (root.matches?.('[data-pfp-product]')) initialise(root);
    root.querySelectorAll?.('[data-pfp-product]').forEach(initialise);
    if (root.matches?.('[data-pfp-details]')) initialiseDetails(root);
    root.querySelectorAll?.('[data-pfp-details]').forEach(initialiseDetails);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  else initialiseAll();
  document.addEventListener('shopify:section:load', event => initialiseAll(event.target));
})();
